import { apiRoutes } from '../../api-routes';
import { httpClient } from '../../util';
import type { SavedPlace, SavedPlaceParams } from './types';

export const updateUserPlaceFn = async (body: SavedPlaceParams) => {
  const response = await httpClient.put<SavedPlace>(
    apiRoutes.place.savedPlaces,
    body
  );
  return response.data;
};
